"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectDateFormatOption', function selectDateFormatOption(dateFormat) {
    var optionState = store_1.default();
    optionState.selectedDateFormat = dateFormat;
});
//# sourceMappingURL=selectDateFormatOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/selectDateFormatOption.js
// module id = 4939
// module chunks = 2